import React from 'react';
import propTypes from 'prop-types';
import{
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Container
} from 'reactstrap';
import classnames from 'classnames';
import api from '../../../../utils/Api';
import ButtonLoading from '../../../../components/Button/ButtonLoading';
import SelectBeneficiaryBank from '../../../../components/Form/Select/Async/SelectBeneficiaryBank';

import { hasError, errorMessage, textChange, textValue } from '../../../../utils/form';

export default class ModalUserBankAccount extends React.Component{
  constructor(props){
    super(props);
    this.state={
      mode: 'NEW',
      error: null,
      bankSelectValue: null,
      manualBankChanged: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleBankChange = this.handleBankChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._prefillBankOption = this._prefillBankOption.bind(this);
    this.prefillRequestSeq = 0; // used to drop stale prefill responses
    this._isMounted = false; // guard setState after unmount
  }

  componentDidMount(){
    this._isMounted = true;
  }

  componentWillUnmount(){
    this._isMounted = false;
    this.prefillRequestSeq++; // invalidate in-flight prefill calls
  }

  handleChange(e){
    this.setState(textChange(e,{...this.state}));
  }

  handleBankChange(selected){
    this.setState({
      bankName: selected ? selected.value : '',
      bankSelectValue: selected,
      manualBankChanged: true
    });
  }

  onSubmit(e){
    e.preventDefault();
    const { 
      userId,
      id,
      bankName,
      accountName,
      accountNumber,
      mode
    } = this.state;
    const payload = { bank_name: bankName, account_name: accountName, account_number: accountNumber };
    if(mode==='EDIT'){
      payload.id = id;
    }
    this.setState({
      error: null
    })
    this.props.onSubmit(userId, payload);
  }
  componentDidUpdate(lastProps){
    if(lastProps.isOpen!=this.props.isOpen && this.props.isOpen){
      const {
        userId,
        id, 
        bankName,
        accountName,
        accountNumber,
        mode
      } = this.props;
      this.setState({
        userId,
        id, 
        bankName,
        accountName,
        accountNumber,
        mode,
        error: null,
        bankSelectValue: bankName ? { name: bankName.toUpperCase(), value: bankName.toUpperCase() } : null,
        manualBankChanged: false
      }, () => {
        if(mode === 'EDIT' && bankName){
          this._prefillBankOption(bankName);
        }
      })
    }
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.dataBankAccount.isSubmit !== this.props.dataBankAccount.isSubmit && !nextProps.dataBankAccount.isSubmit){
      if(nextProps.dataBankAccount.error!==null){
        this.setState({
          error: nextProps.dataBankAccount.error
        })
      }
    }
  }

  _prefillBankOption(bankName){
    const requestedBank = bankName ? bankName.toUpperCase() : '';
    const requestSeq = ++this.prefillRequestSeq;
    api().get('/beneficiary-banks', { params: { keyword: bankName } })
    .then(({ data })=>{
      if(requestSeq !== this.prefillRequestSeq || !this._isMounted){
        return;
      }
      const bank = data.data.find(item => item.name && item.name.toUpperCase() === requestedBank);
      const bankNameChanged = (this.state.bankName || '').toUpperCase() !== requestedBank;
      if(!this.props.isOpen || this.state.manualBankChanged || bankNameChanged){
        return;
      }
      if(bank){
        this.setState({
          bankSelectValue: {
            name: `${bank.name.toUpperCase()} - ${bank.code.toUpperCase()}`,
            value: bank.name.toUpperCase()
          }
        })
      }
    })
    .catch((err)=>{
      // surface failures for debugging; keep silent UX
      console.warn('prefill bank option failed', err);
    })
  }

  render(){
    const selectedBank = this.state.bankSelectValue || (this.state.bankName ? {name: this.state.bankName.toUpperCase(), value: this.state.bankName.toUpperCase()} : null);
    return(
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.onCancel} 
        className="modal-dialog modal-md"
      >
        <ModalHeader toggle={this.props.onCancel}>
          User Bank Account Form
        </ModalHeader>
        <Form onSubmit={this.onSubmit}>
          <ModalBody>
            <Container>
              <Row>
                <Col xs={12}>
                  <FormGroup className={classnames({'has-danger has-feedback':hasError('bank_name',this.state.error)})}>
                    <Label for="formBankAccountBankName">Bank Name*</Label>
                    <SelectBeneficiaryBank
                      id="formBankAccountBankName"
                      name="bankName"
                      placeholder="Type and select a bank..."
                      noResultsText="Bank not found"
                      value={selectedBank}
                      onSelectChange={this.handleBankChange}
                    />
                    {errorMessage('bank_name',this.state.error)}
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup  className={classnames({'has-danger has-feedback':hasError('account_number',this.state.error)})}>
                    <Label for="formBankAccountAccountNumber">Account Number*</Label>
                    <Input
                      type="text"
                      id="formBankAccountAccountNumber"
                      name="accountNumber"
                      placeholder="Account Number"
                      value={textValue('accountNumber',this.state)}
                      onChange={this.handleChange}
                    />
                    {errorMessage('account_number',this.state.error)}
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup  className={classnames({'has-danger has-feedback':hasError('account_name',this.state.error)})}>
                    <Label for="formBankAccountAccountName">Account Name*</Label>
                    <Input
                      type="text"
                      id="formBankAccountAccountName"
                      name="accountName"
                      placeholder="Pemilik No. Rekening"
                      value={textValue('accountName',this.state)}
                      onChange={this.handleChange}
                    />
                    {errorMessage('account_name',this.state.error)}
                  </FormGroup>
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <ButtonLoading
              color="primary" 
              isLoading={this.props.isSubmit}
            >
              Submit
            </ButtonLoading>{' '}
            <Button type="button" color="secondary" onClick={this.props.onCancel}>Cancel</Button>
          </ModalFooter>
        </Form>      
      </Modal>
    )
  }
}
ModalUserBankAccount.defaultProps={
  mode: 'NEW',
  isOpen: false,
  isSubmit: false
}
ModalUserBankAccount.propTypes={
  mode: propTypes.oneOf(['NEW', 'EDIT']),
  isOpen: propTypes.bool,
  isSubmit: propTypes.bool,
  userId: propTypes.number.isRequired,
  id: propTypes.number,
  bankName: propTypes.string,
  accountName: propTypes.string,
  accountNumber: propTypes.string,
  onCancel: propTypes.func,
  onSubmit: propTypes.func,
  dataBankAccount: propTypes.object.isRequired
}
